import React from 'react';
import styles from './CustomPagination.module.css';

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  lazyLoading,
  hidePagination = false,
  totalItems = 0,
  itemsPerPage = 0,
  hasNext,
}) => {
  const effectiveTotalPages =
    hasNext !== undefined
      ? Math.max(1, hasNext ? currentPage + 1 : currentPage)
      : Math.max(1, totalPages);

  const pageNumbers = [];
  for (let i = 1; i <= effectiveTotalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = () => {
    const displayRange = 2; // Number of pages to display on each side of the current page
    let rangeStart = Math.max(1, currentPage - displayRange);
    let rangeEnd = Math.min(effectiveTotalPages, currentPage + displayRange);
    const pages = [];
    if (rangeStart > 1) {
      pages.push(1);
      if (rangeStart > 2) {
        pages.push('left');
      }
    }
    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(i);
    }
    if (rangeEnd < effectiveTotalPages) {
      if (rangeEnd < effectiveTotalPages - 1) {
        pages.push('right');
      }
      pages.push(effectiveTotalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`${styles.paginationItem} ${currentPage === page ? styles.active : ''}`}
      >
        {page === 'left' || page === 'right' ? (
          <button 
            className={`${styles.paginationButton} ${styles.ellipsis}`}
            onClick={() => handleEllipsisClick(page)}
            disabled={lazyLoading}
          >
            ...
          </button>
        ) : (
          <button 
            className={styles.paginationButton}
            onClick={() => onPageChange(page)} 
            disabled={lazyLoading}
          >
            {page}
          </button>
        )}
      </li>
    ));
  };

  const handleEllipsisClick = (direction) => {
    const jump = 5; // Number of pages to jump
    let newPage;
    if (direction === 'left') {
      newPage = Math.max(1, currentPage - jump);
    } else {
      newPage = Math.min(effectiveTotalPages, currentPage + jump);
    }
    onPageChange(newPage);
  };

  const isNextDisabled =
    hasNext !== undefined ? !hasNext || lazyLoading : currentPage === effectiveTotalPages || lazyLoading;

  if (hidePagination || effectiveTotalPages < 1) {
    return null;
  }

  return (
    <div className={styles.paginationContainer}>
     {!!itemsPerPage && !!totalItems && <div className={styles.paginationInfo}>
        Showing {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} Items
      </div>}
      <ul className={styles.pagination}>
        <li className={styles.paginationItem}>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1 || lazyLoading}
            className={`${styles.paginationButton} ${styles.paginationNav}`}
          >
            Prev
          </button>
        </li>
        {renderPageNumbers()}
        <li className={styles.paginationItem}>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={isNextDisabled}
            className={`${styles.paginationButton} ${styles.paginationNav}`}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CustomPagination;
